import { z } from "zod";
import { isValidUrlString } from "./field-definitions.url.logic.ts";

/**
 * @description One tracked shipment for a MAT (material) request — a URL to the
 * carrier's tracking page plus manually-entered delivery metadata. Stored as the
 * payload value of a `shipping_entry_list` field definition (BEL-777). Replaces
 * the plain `url_list` (string[]) previously used on MAT shipment transitions,
 * which had no room for per-URL metadata.
 */
export const ShippingEntry = z.object({
  url: z
    .string()
    .refine(isValidUrlString, "shipping entry url must be a valid URL"),
  // snake_case: this is the raw payload shape stored in the JSON column and
  // used verbatim by both frontend and backend (no camelCase conversion).
  estimated_delivery: z.string().nullable(),
  notes: z.string(),
});
export type ShippingEntry = z.infer<typeof ShippingEntry>;

export const ShippingEntryList = z.array(ShippingEntry);
export type ShippingEntryList = z.infer<typeof ShippingEntryList>;
